// extracted by mini-css-extract-plugin
export default {"card":"card__i8Byh8_U","footerContainer":"footerContainer__khnUscIR","submitButton":"submitButton__QfKOA_Ix"};